import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
// @ts-ignore Ignore unused commented AuthGuard import
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AuthGuard } from '@next/core-lib';

import { AgrPageToolbarModule, AgrPrimaryActionModule } from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';

import { provideEffects } from '@ngrx/effects';

import { provideState } from '@ngrx/store';

import { OfferConfirmationScreenComponent } from './offer-confirmation/offer-confirmation-screen.component';
import { OfferComponent } from './offer.component';
import { SharedModule } from '../shared/shared.module';

import { manureReducer } from '../store/reducer';
import { OfferEffects } from './store/effects/offer.effects';

@NgModule({
  declarations: [OfferComponent, OfferConfirmationScreenComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    AgrPageToolbarModule,
    AgrPrimaryActionModule,
    AgrFormModule,
    MatSelectModule,
    MatRadioModule,
    MatInputModule,
    MatTooltipModule,
    AgrFormModule,
    AgrDialogModule,
    MatDialogModule,
  ],
  providers: [provideEffects([OfferEffects]), provideState('app', manureReducer)],
})
export class OfferModule {}
